import { render } from "./classesList.vue?vue&type=template&id=1a62b6be&ts=true"
import script from "./classesList.vue?vue&type=script&lang=ts"
export * from "./classesList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__